import React, { useState } from 'react';
import {
  TopToolbar,
  CreateButton,
  Button,
} from 'react-admin';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import PricingRulesImportDialog from './PricingRulesImportDialog';

const PricingRulesActions = () => {
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);

  return (
    <TopToolbar>
      <CreateButton />
      <Button
        label="Import"
        onClick={() => setIsImportDialogOpen(true)}
        startIcon={<FileUploadIcon />}
      />
      <PricingRulesImportDialog
        open={isImportDialogOpen}
        onClose={() => setIsImportDialogOpen(false)}
      />
    </TopToolbar>
  );
};

export default PricingRulesActions;
